import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setResolve: YJSChangeHandler<DatabaseChangeType.SET_RESOLVE> = ({
  ydb,
  change,
}) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.resolve = change.resolve;
  });
};
